/*
 * @Author: Ashley.Liu
 * @Date: 2022-09-01 14:58:20
 * @LastEditTime: 2022-09-01 15:02:58
 * @Description: desc
 */
import AsPaginationSelect from './select'
AsPaginationSelect.install = (Vue) => {
  Vue.component(AsPaginationSelect.name, AsPaginationSelect)
}

export default AsPaginationSelect
